module.exports = __webpack_public_path__ + "media/img/about/world-map-bd61471ee69733f0c66f3daa77459f9d.png";